module.exports = __webpack_public_path__ + "static/media/warning-circle.1d2d9c5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/warning-circle.svg
// module id = 2478
// module chunks = 7